import "../../index61.css";
import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { CheckFillIcon as h } from "@ifrc-go/icons";
import { _ as r } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import C from "../InlineLayout/index.js";
import P from "../../hooks/useSpacingToken.js";
const T = "_tab-layout_118d0_1", W = "_color-variant-text_118d0_17", g = "_color-variant-primary_118d0_21", x = "_color-variant-secondary_118d0_25", w = "_style-variant-tab_118d0_29", B = "_active_118d0_38", L = "_style-variant-nav_118d0_50", D = "_style-variant-pill_118d0_60", k = "_style-variant-vertical_118d0_71", F = "_style-variant-vertical-compact_118d0_88", I = "_style-variant-step_118d0_102", j = "_disabled_118d0_112", A = "_tab-wrapper_118d0_121", O = "_active-border_118d0_127", q = "_bottom-border_118d0_138", z = "_step-wrapper_118d0_144", E = "_dot_118d0_149", G = "_icon_118d0_159", H = "_dot-wrapper_118d0_165", J = "_before-dot_118d0_170", K = "_after-dot_118d0_179", M = "_completed_118d0_197", Q = "_first-step_118d0_210", R = "_last-step_118d0_223", t = {
  tabLayout: T,
  colorVariantText: W,
  colorVariantPrimary: g,
  colorVariantSecondary: x,
  styleVariantTab: w,
  active: B,
  styleVariantNav: L,
  styleVariantPill: D,
  styleVariantVertical: k,
  styleVariantVerticalCompact: F,
  styleVariantStep: I,
  disabled: j,
  tabWrapper: A,
  activeBorder: O,
  bottomBorder: q,
  stepWrapper: z,
  dot: E,
  icon: G,
  dotWrapper: H,
  beforeDot: J,
  afterDot: K,
  completed: M,
  firstStep: Q,
  lastStep: R
}, U = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary
}, X = {
  tab: t.styleVariantTab,
  pill: t.styleVariantPill,
  step: t.styleVariantStep,
  nav: t.styleVariantNav,
  vertical: t.styleVariantVertical,
  "vertical-compact": t.styleVariantVerticalCompact
};
function ot(l) {
  const {
    colorVariant: d = "primary",
    styleVariant: e = "nav",
    spacingOffset: p = e === "tab" ? 1 : 0,
    className: _,
    disabled: m,
    children: y,
    withoutPadding: v = !1,
    active: o,
    spacing: V,
    tabWrapperClassName: b,
    stepCompleted: i,
    isFirstStep: f,
    isLastStep: N,
    errored: S,
    ...u
  } = l, n = P({
    modes: ["padding-inline"],
    spacing: V,
    offset: -5
  }), c = /* @__PURE__ */ s(
    C,
    {
      ...u,
      withPadding: !(v || e === "vertical-compact" || e === "nav"),
      className: r(
        t.tabLayout,
        U[d],
        X[e],
        i && t.completed,
        m && t.disabled,
        o && t.active,
        // FIXME: implement this
        S && t.errored,
        _
      ),
      spacingOffset: p,
      withAdditionalInlinePadding: e === "pill",
      children: [
        y,
        /* @__PURE__ */ a("span", { className: t.visualFeedback })
      ]
    }
  );
  return e === "tab" ? /* @__PURE__ */ s(
    "div",
    {
      className: r(
        t.tabWrapper,
        b,
        o && t.active
      ),
      children: [
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, n) }),
        c,
        /* @__PURE__ */ a("div", { className: r(t.bottomBorder, n) }),
        o && /* @__PURE__ */ a("div", { className: t.activeBorder })
      ]
    }
  ) : e === "step" ? /* @__PURE__ */ s(
    "div",
    {
      className: r(
        t.stepWrapper,
        o && t.active,
        i && t.completed,
        f && t.firstStep,
        N && t.lastStep
      ),
      role: "tab",
      children: [
        /* @__PURE__ */ s("div", { className: t.dotWrapper, children: [
          /* @__PURE__ */ a("div", { className: t.beforeDot }),
          /* @__PURE__ */ a("div", { className: t.dot, children: i && /* @__PURE__ */ a(h, { className: t.icon }) }),
          /* @__PURE__ */ a("div", { className: t.afterDot })
        ] }),
        c
      ]
    }
  ) : c;
}
export {
  ot as default
};
